<template>
  <!--
      @TODO:
      separate form-items
     -->
  <el-form
    :model="form"
    v-loading="loading.state"
    :element-loading-text="loading.msg"
    :rules="rules"
    ref="early-voting-form"
    class="early-voting-form"
  >
    <el-row v-if="configSet['name-show']" :gutter="20">
      <el-col :span="4">
        <el-form-item label="Prefix" prop="prefix" :inline-message="true">
          <el-select v-model="form.prefix">
            <el-option
              v-for="pf in configSet['prefix-list']['items']"
              :key="pf.prefix"
              :placeholder="pf.prefix"
              :value="pf.prefix"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="10">
        <el-form-item
          label="First Name"
          prop="firstName"
          :inline-message="true"
        >
          <el-input placeholder="i.e John" v-model="form.firstName" />
        </el-form-item>
      </el-col>
      <el-col :span="10">
        <el-form-item label="Last Name" prop="lastName" :inline-message="true">
          <el-input placeholder="i.e Doe" v-model="form.lastName" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row v-if="configSet['mobile-show']">
      <el-col :span="24">
        <el-form-item
          label="Mobile Number"
          :inline-message="true"
          prop="mobile"
        >
          <el-input v-model="form.mobile" placeholder="Mobile number" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row v-if="configSet['email-show']">
      <el-col>
        <el-form-item label="Email" :inline-message="true" prop="email">
          <el-input
            v-model="form.email"
            placeholder="name@email.com"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <template v-if="configSet['address-show']">
      <el-row>
        <el-col>
          <!-- 1 if manual address input -->

          <el-form-item
            label="Address"
            prop="street"
            v-if="!configSet['address-typedown']"
          >
            <el-input
              v-model="form.street"
              prefix-icon="el-icon-search"
              placeholder="Enter Your Address"
            />
          </el-form-item>

          <!-- 2 if google search is enabled -->
          <el-form-item v-else prop="street" label="Address">
            <el-input
              v-model="form.street"
              prefix-icon="el-icon-search"
              @input="searchInit"
              @focus="showAddressResults = true"
              @clear="showAddressResults = false"
              clearable
              placeholder="Enter your Address"
            />

            <!-- google address search result -->

            <div
              v-if="showAddressResults"
              class="custom-dropwndown el-select-dropdown el-popper"
            >
              <ul class="el-scrollbar__view el-select-dropdown__list">
                <li
                  class="el-select-dropdown__item"
                  v-for="(item, i) in resultsArr"
                  :key="i"
                  @click="onSelectAddress(item.description)"
                >
                  {{ item.description }}
                </li>
                <li
                  class="el-select-dropdown__item hover"
                  @click="showAddressResults = false"
                >
                  close
                </li>
              </ul>
            </div>

            <!-- google address search result END -->
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-form-item label="Suburb" prop="suburb">
            <el-input v-model="form.suburb" placeholder="Suburb" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12" class="state-item">
          <el-form-item label="State" prop="state" :inline-message="true">
            <el-select v-model="form.state">
              <el-option
                v-for="(item, i) in configSet['state-list']['items']"
                :key="i"
                :placeholder="item['state-name']"
                :value="item['state-name']"
                >{{ item["state-name"] }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :inline-message="true" prop="postcode" label="Postcode">
            <el-input v-model="form.postcode" placeholder="Enter" />
          </el-form-item>
        </el-col>
      </el-row>
    </template>

    <el-button class="submit-btn" type="primary" @click="onSubmitForm">
      {{ configSet["submit-button-label"] }}
      <svg xmlns="http://www.w3.org/2000/svg" class="submit-ico icon icon-tabler icon-tabler-arrow-right" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#FFF" fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <line x1="5" y1="12" x2="19" y2="12" />
        <line x1="13" y1="18" x2="19" y2="12" />
        <line x1="13" y1="6" x2="19" y2="12" />
      </svg>
    </el-button>

    <el-dialog :visible.sync="successModal" class="actionform-dialog">
      <div class="redirect-content" v-html="popupContent" />

      <div slot="footer" class="dialog-footer">
        <a :href="redirectUrl">
          <el-button type="primary">
          {{ configSet['pva-success-button-label'] }}
          </el-button>
        </a>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="failModal" class="actionform-dialog">
      <div class="redirect-content" v-html="popupContent" />

      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="failModal = false"
        >
          {{ configSet['pva-failure-button-label'] }}
        </el-button>
      </div>
    </el-dialog>


  </el-form>
</template>

<script>
/*
import UserInfo from "../components/_FormElements/UserInfo.vue";
import UserContact from "../components/_FormElements/UserContact.vue";
 */
import _ from "lodash";

import axios from "axios";
import {addressParser} from "@helpers/addressParser";

// import {
//   ValidateMobileNumber,
//   ValidateEmail
// } from '../_helper/validation.js'
let configType = '';

if(window['action-form']) {
  configType = window['action-form']['configurationSet']
}

export default {
  name: "Action-Form",
  // components: { UserInfo, UserContact },
  data() {
    return {
      // @TODO get API config  for the form state
      loadingAddress: false,
      showAddressResults: false,
      successModal: false,
      failModal: false,
      redirectUrl: "",
      popupContent: "",
      resultsArr: [],
      configSet: {},
      loading: {
        state: false,
        msg: "",
      },
      form: {
        prefix: "",
        firstName: "",
        lastName: "",
        mobile: "",
        email: "",
        street: "",
        suburb: "",
        state: "",
        postcode: "",
      },
      rules: {
        firstName: {
          required: false,
          trigger: "blur",
          message: "",
        },
        lastName: {
          required: false,
          trigger: "blur",
          message: "",
        },
        email: {
          required: false,
          trigger: "blur",
          message: "",
        },
        mobile: {
          required: false,
          trigger: "blur",
          message: "",
        },
        street: {
          required: false,
          trigger: "blur",
          message: "",
        },
        postcode: {
          required: false,
          trigger: "blur",
          message: "",
        },
        state: {
          required: false,
          trigger: "blur",
          message: "",
        },
      },
    };
  },
  methods: {
    getConfig() {
      const apiOptions = {
        method: "get",
        baseURL: "/api/",
        url: `config/${configType}`,
      };
      this.loading = {
        state: true,
        msg: "Loading Form Configuration...",
      };
      axios(apiOptions)
        .then((res) => {
            this.configSet = res.data[`${configType}`]
        })
        .catch((err) => {
          if (err) {
            console.log(err)
          }
        })
        .finally(() => {
          this.setValidation();
          this.loading = false;
          if(this.configSet['address-typedown']) {          
            this.gmapsInit(this.configSet['api-keys']['address-typedown-api-key'])
          }
        });
    },
    setValidation() {
      this.rules.firstName = {
        required: this.configSet["name-required"],
        message:
          this.configSet["validation-contact-form"]["missing-first-name"],
      };
      this.rules.lastName = {
        required: this.configSet["name-required"],
        message: this.configSet["validation-contact-form"]["missing-last-name"],
      };
      this.rules.email = {
        required: this.configSet["email-required"],
        message: this.configSet["validation-contact-form"]["missing-email"],
      };
      this.rules.mobile = {
        required: this.configSet["mobile-required"],
        message:
          this.configSet["validation-contact-form"]["missing-mobile-number"],
      };

      if (this.configSet["address-required"]) {
        this.rules.street = {
          required: true,
          message: this.configSet["validation-contact-form"]["missing-address"],
        };
        this.rules.state = {
          required: true,
          message: this.configSet["validation-contact-form"]["missing-state"],
        };
        this.rules.postcode = {
          required: true,
          message:
            this.configSet["validation-contact-form"]["missing-postcode"],
        };
      }
    },
    // populate address on select
    async onSelectAddress(address) {

      const { streetAddress, suburb, state, postcode } = await addressParser.parseAddress(address)

      this.form.street = streetAddress
      this.form.suburb = suburb
      this.form.state = state
      this.form.postcode = postcode

      this.showAddressResults = false;
    },
    // start querying address
    searchInit: _.debounce(async function (query) {

      if (!query) return

      try {
        this.loadingAddress = true
        this.resultsArr = await addressParser.addressLookup(query)
        this.showAddressResults = !!this.resultsArr.length

      } catch (error) {
        console.log('')
      } finally {
        this.loadingAddress = false
      }

    }, 100),

    onSubmitForm() {
      const apiOptions = {
        method: "post",
        url: "vote/early",
        baseURL: "/api/",
        data: {
          "electorate-type": this.configSet["electorate-type"],
          action: this.configSet["action-type"],
          configSetName: "federal-2022",
          individual: {
            prefix: this.form.prefix,
            first_name: this.form.firstName,
            last_name: this.form.lastName,
            dob: "",
            mobile: this.form.mobile,
            email: this.form.email,
            address: {
              address_1: this.form.street,
              address_2: null,
              address_3: null,
              suburb: this.form.suburb,
              state: this.form.state,
              post_code: this.form.postcode,
            },
          },
        },
      };
      this.$refs["early-voting-form"].validate((valid) => {
        if (valid) {
          this.loading = {
            state: true,
            msg: "Processing...",
          };
          axios(apiOptions)
            .then((res) => {
              this.popupContent = this.configSet["pva-success-content"].replace('&lt;ElectorateName&gt;', res.data['ElectorateName'])
              this.redirectUrl = res.data["UrlRedirect"];
              this.successModal = true;
              this.redirectPage();
            })
            .catch(() => {
              this.failModal = true;
              this.popupContent = this.configSet["pva-failure-content"]
            })
            .finally(() => {
              this.loading.state = false
            })
        }
      });
    },
    gmapsInit(key) {
      console.log(window)
      
      if(!window.googleMapUri) {
          window.googleMapUri = `https://maps.googleapis.com/maps/api/js`
        }

        function initGmaps() {
          let instance = 0;
          // check if google script exist already
          document.querySelectorAll('script').forEach(scriptTag => {
            if(scriptTag.src) {
              if(scriptTag.src.includes(window.googleMapUri)) {
                instance = 1;
              }
            }
          })

          if(instance === 0) {
            appendScript()
          }
        }

        function appendScript() {
          const script = document.createElement("script");

          script.src = window.googleMapUri + `?key=${key}&callback=initMap&libraries=places`;
          script.async = true;

          document.body.appendChild(script);
        }


        initGmaps()
    },
    redirectPage() {
      setTimeout(() => {
        window.location.href = this.redirectUrl;
      }, this.configSet["redirect-delay"] * 1000);
    
    },
  },
  mounted() {
    this.getConfig();
  },
};
</script>

<style lang="scss">
.early-voting-form {
  .state-item {
    .el-form-item {
      width: 100%;
      
      .el-select {
        display: block;

        .el-input__suffix {
          top: 32px;
        }
      }

      .el-popper[x-placement^=bottom] {
         margin-top: 40px; 
      }
    }
  }
  .el-row {
    margin-bottom: 8px;
  }

  .el-form-item__label {
    margin-bottom: -6px;
  }

  .el-button--primary {
    background: #00529B;
    border-color: #00529B;

    &:hover {
      background: #023b6e;
      border-color: #023b6e;
    }
  }

  .el-button--primary.submit-btn {
    width: 100%;
    background: #00529B;
    border-color: #00529B;
    height: 56px;
    text-transform: uppercase;
    font-size: 20px;
    font-weight: bold;
    position: relative;
    margin-top: 16px;

    

    &:hover {
      background: #023b6e;
      border-color: #023b6e;
    }


    svg {
      position: absolute;
      width: 25px;
      right: 20px;
      top: 4px;
    }
  }
}
.el-input .el-input__inner {
  height: 48px !important;

}
.actionform-dialog .el-dialog {
  width: 90%;
  
  @media screen and (min-width: 768px) {
    width: 50%;
  }
  @media screen and (min-width: 1024px) {
    width: 30%;
  }
}
.state-item {
  display: flex;
}
.redirect-content {
  word-break: break-word;

  h1 {
    font-size: 20px;
    line-height: 24px;
  }
}
</style>